import { render, staticRenderFns } from "./ActivateExam.vue?vue&type=template&id=97b13062&lang=pug&"
import script from "./ActivateExam.vue?vue&type=script&lang=js&"
export * from "./ActivateExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports